import { Copy } from "lucide-react";
import i18n from "i18next";

/**
 * Aviso de posible factura duplicada (2-11-2026). Con `duplicate_check` en la plantilla, el procesador busca en su historial otra
 * factura con el mismo proveedor, número y total y marca `extracted_json.duplicate_of = { result_id, created_at }`. Solo avisa:
 * la página se cobra igual, y el usuario decide si la borra o la deja fuera de su exportación.
 */
// Fecha en el idioma de la app (no el del navegador): un usuario con la app en italiano y el navegador en inglés vería 10/05 por 5 de octubre.
export const formatDuplicateDate = (iso, lang = i18n.language) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleDateString(lang || undefined, { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d.toISOString().slice(0, 10);
  }
};

export default function DuplicateNotice({ extractedJson, t, className = "mb-4" }) {
  const dup = extractedJson?.duplicate_of;
  if (!dup || !dup.result_id) return null;
  const date = formatDuplicateDate(dup.created_at);
  return (
    <div role="status" data-testid="duplicate-notice" className={`${className} flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900`}>
      <Copy size={18} className="mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">{date ? t("duplicateInvoice.title", { date }) : t("duplicateInvoice.titleNoDate")}</p>
        <p className="mt-1">{t("duplicateInvoice.body")}</p>
      </div>
    </div>
  );
}
